module.exports = __webpack_public_path__ + "173d10299ec0552f559e1b79b6ae1ba0.svg";